import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const Upscore = (props: SvgProps) => (
  <Svg width='8' height='6' viewBox='0 0 8 6' fill='none' {...props}>
    <Path
      d='M1.14062 6C0.726678 6 0.390625 5.6195 0.390625 5.1508L0.390625 2.56213C0.390625 2.37566 0.487435 2.20683 0.637657 2.13123L1.89062 1.5V5.1508C1.89062 5.6195 1.55457 6 1.14062 6Z'
      fill='white'
    />
    <Path
      d='M4.14062 6C3.72668 6 3.39063 5.63007 3.39063 5.17439L3.39062 3.28263C3.39062 3.10134 3.48743 2.93719 3.63766 2.8637L4.89062 2.25V5.17439C4.89062 5.63007 4.55457 6 4.14062 6Z'
      fill='white'
    />
    <Path
      d='M7.14062 6C6.72668 6 6.39062 5.60537 6.39062 5.11928L6.39063 1.10165C6.39063 0.908255 6.48743 0.733156 6.63766 0.654753L7.89062 9.2593e-05V5.11928C7.89062 5.60537 7.55457 6 7.14062 6Z'
      fill='white'
    />
  </Svg>
)
